import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VaccineService {

  constructor(private httpClient: HttpClient, private toastr: ToastrService) { }
  private apiUrl = environment.apiUrl;

  getVaccinationList(): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/Vaccination/HatcheryVaccinationList`).pipe(
      catchError(this.error)
    );;
  }
  getMainVaccinationList(): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/Vaccination/VaccineList`).pipe(
      catchError(this.error)
    );;
  }
  // Handle Errors
  error(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }

  addVaccineDetail(vaccineModel: any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/Vaccination/AddVaccine`, vaccineModel).pipe(
      //catchError(this.error)
    );;
  }

  getVaccineList(page: any, pageSize: any,filters?: any): Observable<any> {
    const params = {page,pageSize};
  return this.httpClient.post(
    `${this.apiUrl}/Vaccination/GetVaccineList`,filters || {},{ params }
  );

  }

  getVaccineDetailsById(id: number): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/Vaccination/GetVaccineDetailsById?id=${id}`).pipe(
      //catchError(this.error)
    );;
  }

  updateVaccineDetail(vaccineModel: any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/Vaccination/UpdateVaccineDetail`, vaccineModel).pipe(
      //catchError(this.error)
    );;
  }

  deleteVaccine(vaccineId: number): Observable<any> {
    return this.httpClient.delete(`${this.apiUrl}/Vaccination/DeleteVaccine?id=${vaccineId}`).pipe(
      //catchError(this.error)
    );
  }

  getVaccineDetailsInfoById(id: number): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/Vaccination/VaccineDetailInfoById?id=${id}`).pipe(
      //catchError(this.error)
    );;
  }

}
